// extracted by mini-css-extract-plugin
export default {"panelWrapper":"QuestionNavigationPanel_panelWrapper__Lq6eO"};